import { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useLocation } from 'react-router-dom';
import { Grid, LinearProgress } from '@mui/material';
import { MatomoEventTrackMapObject } from '../constants/constant';
import ClusterSummaryTopBar from './cluster-summary-top-bar';
import ClusterSummaryFooter from './cluster-summary-footer';
import useMatomoFunction from 'src/hooks/use-matomo-function.hook';
import ClusterSummaryTableData from './cluster-summary-table-component';
import { fetchClusterSummaryData, resetscenarioSelectionState } from './store/cluster-summary-slice';
import ClusterSummaryToggleButtons from './cluster-togglegroup';
import useModulePreRequisites from '../common/hooks/use-module-pre-requisites.hook';
import MODULE_TO_PAGE_MAP from '../home/types/simulation-module-to-page-map';

export default function ClusterSummary(){
  const appDispatch = useAppDispatch();
  const sourceId = useAppSelector((state) => state.user.source);
  const {selectedSourceKey,
    sourceSelectedRowsMap,
  } = useAppSelector((state) => state.clusterSummary);
  
  
  // Get selected rows for current source, fallback to empty array
  const selectedRows = sourceSelectedRowsMap[selectedSourceKey] || [];
  const [localSelectedRows, setLocalSelectedRows] = useState([]);
    
  const { callFunction } = useMatomoFunction();
  
  const getPageName = () => {
    const page_title = window.location.href.split('/').at(-1);
    return page_title;
  };
  
  useEffect(() => {
    callFunction(
      MatomoEventTrackMapObject.track_page_view.event_key,
      getPageName()
    );
  }, []);

  const { isFetchingPreRequisites } = useModulePreRequisites({
    module: MODULE_TO_PAGE_MAP.PLANNER,
    onPreRequisitesFetched() {
      // Fetch initial cluster summary data when pre-requisites are ready
      appDispatch(fetchClusterSummaryData({ sourceId }));
      appDispatch(resetscenarioSelectionState());
      
    }
  });
  

  // Update local state when Redux state changes
  useEffect(() => {
    setLocalSelectedRows(selectedRows);
  }, [selectedRows]);


  return(
    <Grid sx={{ padding: (theme) => theme.spacing(1, 2) }} >
      <Grid item xs={12} sx={{ marginBottom: 2 }}>
        <ClusterSummaryToggleButtons />
      </Grid>
      <Grid item xs={12}>
        <Grid 
          container 
          // spacing={2} 
          sx={{ 
            backgroundColor: '#f5f5f5', 
            borderRadius: '8px',
          }}
        >
          <Grid item xs={12} >
            <Grid item xs={12} >
            <ClusterSummaryTableData
              onRowSelectionChange={setLocalSelectedRows}
            />
          </Grid>
          <Grid item xs={12}
            sx={{ 
            backgroundColor: '#f5f5f5'}}> 
            <ClusterSummaryFooter selectedScenarios={localSelectedRows}/>
          </Grid>

          </Grid>
          
        </Grid>
      </Grid>
    </Grid>
  );
}